module.exports = __webpack_public_path__ + "banquet/components/StoreFeedLayout/images/list_chevron.2b887b796d7fc785872bd6fba5829dd4.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/StoreFeedLayout/images/list_chevron.svg
// module id = 1695
// module chunks = 1